export default "__VITE_ASSET__92eeab8f__"